import {
    globalStore
} from '../helpers';

export function handleException(error) {
    if (error.response.status == 401) {
        globalStore.loginState.logout();
        location.reload(true);

        return Promise.resolve();
    }

    return Promise.reject({status:error.response.status, statusText:error.response.statusText});
}